const productsAvailable = state => {
  return state.documents.values.prodottiDisponibili ? state.documents.values.prodottiDisponibili : null;
}

export default productsAvailable;
